export function hamburger () {
  const hamburger = document.querySelector('.js-hamburger');
  const hamburgerNav = document.querySelector('.js-hamburgerNav');
  const hamburgerNav_link = hamburgerNav.querySelectorAll('a');

  hamburger.addEventListener('click', () => {
    hamburger.classList.toggle('is-active');
    hamburgerNav.classList.toggle('is-active');
  })

  hamburgerNav_link.forEach(link => {
    link.addEventListener('click', () => {
      hamburger.classList.remove('is-active');
      hamburgerNav.classList.remove('is-active');
    });
  });
}